import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/comment-bots/${resource.id}/edit`} />,
    <MenuItem primaryText='Copy' key='copy' value={`/write-now/comment-bots/${resource.id}/copy`} />
  ]
}

export default buildMenuItems
